import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import InputLabel from '@mui/material/InputLabel';
import { Box } from '@mui/material';

const ITEM_HEIGHT = 60;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      maxWidth: 300,
      width: 300,
    },
  },
};

interface MultiSelectDropdownProps {
  inputLabel: string;
  onChange: (event: any) => void;
  value: string[] | string;
  options: { id: string | number; label: string }[];
}

const MultiSelectDropdown = ({ inputLabel, onChange, value, options }: MultiSelectDropdownProps) => {
  const labelId = `${inputLabel.replace(/\s+/g, '-').toLowerCase()}-multi-label`;
  const selectId = `${labelId}-select`;

  const getNormalizedValue = () => {
    if (Array.isArray(value)) {
      return value;
    }
    if (typeof value === 'string' && value.trim().length > 0) {
      return value
        .split(',')
        .map((item) => item.trim())
        .filter(Boolean);
    }
    return [];
  };

  const normalizedValue = getNormalizedValue();

  return (
    <Box>
      <FormControl fullWidth>
        <InputLabel id={labelId}>{inputLabel}</InputLabel>
        <Select labelId={labelId} id={selectId} multiple value={normalizedValue} onChange={onChange} MenuProps={MenuProps} label={inputLabel}>
          {options.map((item: any) => (
            <MenuItem key={item.id} value={item.label}>
              <Checkbox checked={normalizedValue.indexOf(item.label) > -1} />
              {item.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

MultiSelectDropdown.defaultProps = {
  options: [
    { id: 1, label: 'Twenty' },
    { id: 3, label: 'Thirty' },
  ],
  inputLabel: 'Age',
} as Partial<MultiSelectDropdownProps>;

export default MultiSelectDropdown;
